import { AVAILABLE_COLORS } from "common/utils/rtcJobs";
import { FarmPanel } from "./FarmPanel";
import { getSequence } from "portal/utils/robots";
import { jobExplorer, MapView } from "common/state/jobExplorer";
import { Objective } from "protos/rtc/jobs";
import { ObjectivePanel } from "./ObjectivePanel";
import { Paper, Tab, Tabs } from "@mui/material";
import { RobotPanel } from "./RobotPanel";
import { rtcLocatorApi } from "common/state/rtcLocatorApi";
import { skipToken } from "@reduxjs/toolkit/query";
import { useDispatch, useSelector } from "react-redux";
import { useQueryPopups } from "portal/utils/hooks/useApiPopups";
import { useTranslation } from "react-i18next";
import React, { FC, useCallback } from "react";

interface SelectionPanelProps {
  objectives: Objective[];
}
export const SelectionPanel: FC<SelectionPanelProps> = ({ objectives }) => {
  const { setTractorColor } = jobExplorer.actions;
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const job = useSelector(jobExplorer.selectors.selectJob);
  const colorsBySerial = useSelector(
    jobExplorer.selectors.selectColorsBySerial
  );

  const { data: availableTractors } = useQueryPopups(
    rtcLocatorApi.endpoints.listRobots.useQuery(
      job
        ? {
            serials: job.robotWhitelist?.entries.map((r) => r.robotSerial),
          }
        : skipToken
    )
  );

  if (availableTractors?.robots) {
    for (const tractor of availableTractors.robots) {
      const i = getSequence(tractor.serial) % AVAILABLE_COLORS.length;
      if (!colorsBySerial[tractor.serial]) {
        dispatch(
          setTractorColor({
            serial: tractor.serial,
            color: AVAILABLE_COLORS[i] ?? "#FF0000",
          })
        );
      }
    }
  }

  const sortedObjectives = objectives.toSorted(
    (a, b) => a.priority - b.priority
  );

  const tab = useSelector(jobExplorer.selectors.selectMapView);
  const setTab = useCallback(
    (tab: MapView) => {
      dispatch(jobExplorer.actions.setMapView(tab));
    },
    [dispatch]
  );

  return (
    <Paper className="flex flex-col w-full">
      <Tabs
        textColor="inherit"
        indicatorColor="secondary"
        variant="fullWidth"
        value={tab}
        onChange={(_, value) => setTab(value)}
      >
        <Tab
          label={t("models.autotractor.objective_other")}
          value="objectives"
        />
        <Tab label={t("models.robots.robot_other")} value="robots" />
        <Tab label={t("models.farms.farm_one")} value="farm" />
      </Tabs>
      {tab === "farm" && <FarmPanel />}
      {tab === "robots" && (
        <RobotPanel robots={availableTractors?.robots ?? []} />
      )}
      {tab === "objectives" && <ObjectivePanel objectives={sortedObjectives} />}
    </Paper>
  );
};
